import { Link } from "react-router-dom";
import GaugeComponent from "react-gauge-component";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import ProAnalyseModal from "../../test/proAnalyseModal";
import useStore from "../../../features/store";

const Physical = ({ weight, height, bmi, test_id, isResult = false }: any) => {
  const has_physicalData = weight && height && bmi;
  //@ts-ignore
  const { isLoadingProfile } = useStore();

  return (
    <div className="flex-1 relative bg-pr_green rounded-xl w-auto overflow-hidden px-5 py-10 lg:p-10">
      <h3 className="font-rokh font-[900] text-xl">وضعیت فیزیکی</h3>

      <div className="flex flex-col lg:flex-row items-center justify-between">
        {has_physicalData ? (
          <div className="flex-[2] flex items-center justify-center gap-3 mt-5">
            <div className="flex flex-col items-center bg-white w-[80px] p-4 rounded-xl">
              <h6 className="font-rokh font-[700] text-xl">
                {weight ? (
                  <>
                    {weight}
                    <span className="font-rokh font-[700] text-sm ml-1">
                      kg
                    </span>
                  </>
                ) : (
                  "-"
                )}
              </h6>
              <h5 className="font-rokh font-[700]">وزن</h5>
            </div>
            <div className="flex flex-col items-center bg-white w-[80px] p-4 rounded-xl">
              <h6 className="font-rokh font-[700] text-xl">
                {height ? (
                  <>
                    {height}
                    <span className="font-rokh font-[700] text-sm ml-1">
                      cm
                    </span>
                  </>
                ) : (
                  "-"
                )}
              </h6>
              <h5 className="font-rokh font-[700]">قد</h5>
            </div>
            <div className="flex flex-col items-center bg-white w-[80px] p-4 rounded-xl">
              <h6 className="font-rokh font-[700] text-xl">
                {bmi ? bmi : "-"}
              </h6>
              <span className="font-rokh font-[700]">BMI</span>
            </div>
          </div>
        ) : isResult ? (
          <div className="flex-[5] relative bg-white rounded-xl p-5 px-32 lg:px-5 py-12 mt-5 flex items-center justify-between gap-2">
            <ProAnalyseModal id={test_id} top="top-1/4" />
          </div>
        ) : (
          <Link
            to="/test-registration"
            className="flex-[2] relative bg-white rounded-xl p-5 mt-5 flex items-center justify-between gap-2"
          >
            <p className="font-rokh font-[700] text-sm pt-2">
              برای دیدن این اطلاعات، یک آزمایش با تحلیل پیشرفته ثبت کن!
            </p>
            <HiOutlineArrowLongLeft size={35} />
          </Link>
        )}

        <div className="flex-[1]">
          {!isLoadingProfile && (
            <GaugeComponent
              type="semicircle"
              arc={{
                colorArray: [
                  "#A9D284",
                  "#A9D284",
                  "#ECB704",
                  "#F7665E",
                  "#F7665E",
                  "#F7665E",
                ],
                padding: 0.02,
                subArcs: [
                  { limit: 18.5 },
                  { limit: 24.9 },
                  { limit: 29.9 },
                  { limit: 34.4 },
                  { limit: 39.9 },
                  { limit: 45 },
                ],
              }}
              pointer={{
                hide: bmi ? false : true,
                type: "blob",
                animationDelay: 0,
              }}
              labels={{
                valueLabel: {
                  formatTextValue: (value: any) => value,
                  style: {
                    fontSize: "40px",
                    fontWeight: 900,
                    fontFamily: "rokh",
                    marginTop: "20px",
                    fill: "#000",
                    textShadow: "none",
                  },
                },
                tickLabels: {
                  hideMinMax: true,
                },
              }}
              minValue={0}
              maxValue={100}
              value={bmi ? bmi : 0}
            />
          )}
        </div>
      </div>

      <div className="w-full flex flex-col justify-between">
        <div className="flex-[1] flex flex-col items-start border-b border-pr_green_dark mb-3 mt-6">
          <h2 className="font-rokh text-lg font-[900]">شاخص توده بدنی (BMI)</h2>
        </div>
        <div className="flex-[4] w-full">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">کم وزنی: </h6>
              <h6 className="text-xs font-rokh font-[700]">کمتر از 18.5</h6>
            </div>
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">محدوده بهینه: </h6>
              <h6 className="text-xs font-rokh font-[700]">18.5 تا 24.9</h6>
            </div>
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">اضافه وزن: </h6>
              <h6 className="text-xs font-rokh font-[700]">25 تا 29.9</h6>
            </div>
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">چاقی کلاس I: </h6>
              <h6 className="text-xs font-rokh font-[700]"> 30 تا 34.9</h6>
            </div>
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">چاقی کلاس II: </h6>
              <h6 className="text-xs font-rokh font-[700]">35 تا 39.9</h6>
            </div>
            <div className="border border-pr_green_dark rounded p-3 pb-2 flex-1 flex items-center justify-between">
              <h6 className="text-xs font-rokh font-[700]">چاقی کلاس III: </h6>
              <h6 className="text-xs font-rokh font-[700]">بیش از 40</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Physical;
